import { defineDictionary } from "gemi/client";

// Landing page copy added after the legacy HomePageV2 dictionary was frozen
// (see app/i18n/legacyI18nApi.test.ts). Older landing copy still lives in HomePageV2.
export const homeDict = defineDictionary({
  hero_subtitle: {
    "en-US":
      "Turn product photos and files into one catalog that people can shop and AI agents can find.",
    "tr-TR":
      "Ürün fotoğraflarını ve dosyaları, insanların alışveriş yapabileceği ve yapay zeka agent'larının bulabileceği tek bir kataloğa dönüştürün.",
    "de-DE":
      "Machen Sie aus Produktfotos und Dateien einen Katalog, in dem Menschen einkaufen und den KI-Agenten finden.",
    "it-IT":
      "Trasforma foto e file dei prodotti in un unico catalogo dove le persone comprano e che gli agenti IA trovano.",
    "fr-FR":
      "Transformez vos photos et fichiers produit en un seul catalogue où les gens achètent et que les agents IA trouvent.",
    "es-ES":
      "Convierte fotos y archivos de producto en un solo catálogo donde la gente compra y que los agentes de IA encuentran.",
    "ru-RU":
      "Превратите фото и файлы товаров в единый каталог, где люди покупают и который находят ИИ-агенты.",
  },
  done_card_bring: {
    "en-US": "Bring what you know",
    "tr-TR": "Bildiklerinizi getirin",
    "de-DE": "Bringen Sie Ihr Wissen mit",
    "it-IT": "Porta ciò che sai",
    "fr-FR": "Apportez ce que vous savez",
    "es-ES": "Trae lo que sabes",
    "ru-RU": "Принесите то, что знаете",
  },
  done_card_bring_desc: {
    "en-US": "Photos, files and product details come in.",
    "tr-TR": "Fotoğraflar, dosyalar ve ürün bilgileri bir araya gelir.",
    "de-DE": "Fotos, Dateien und Produktdetails kommen zusammen.",
    "it-IT": "Foto, file e dettagli di prodotto entrano.",
    "fr-FR": "Photos, fichiers et détails produit entrent.",
    "es-ES": "Entran fotos, archivos y detalles de producto.",
    "ru-RU": "Фото, файлы и сведения о товаре собираются вместе.",
  },
  done_card_catalog: {
    "en-US": "Build one living catalog",
    "tr-TR": "Yaşayan tek bir katalog oluşturun",
    "de-DE": "Bauen Sie einen lebendigen Katalog",
    "it-IT": "Crea un catalogo vivo",
    "fr-FR": "Créez un catalogue vivant",
    "es-ES": "Crea un catálogo vivo",
    "ru-RU": "Создайте единый живой каталог",
  },
  done_card_catalog_desc: {
    "en-US":
      "Folio organizes it so people and agents can understand every product.",
    "tr-TR":
      "Folio her ürünü insanların ve agent'ların anlayabileceği şekilde düzenler.",
    "de-DE":
      "Folio organisiert alles so, dass Menschen und Agenten jedes Produkt verstehen.",
    "it-IT":
      "Folio organizza tutto perché persone e agenti comprendano ogni prodotto.",
    "fr-FR":
      "Folio organise tout pour que les humains et les agents comprennent chaque produit.",
    "es-ES":
      "Folio lo organiza para que personas y agentes entiendan cada producto.",
    "ru-RU":
      "Folio организует всё так, чтобы люди и агенты понимали каждый продукт.",
  },
  done_card_world: {
    "en-US": "Open it to the world",
    "tr-TR": "Kataloğu dünyaya açın",
    "de-DE": "Öffnen Sie ihn für die Welt",
    "it-IT": "Aprilo al mondo",
    "fr-FR": "Ouvrez-le au monde",
    "es-ES": "Ábrelo al mundo",
    "ru-RU": "Откройте его миру",
  },
  done_card_world_desc: {
    "en-US": "People can shop it. Agents can find it.",
    "tr-TR": "İnsanlar alışveriş yapabilir. Agent'lar bulabilir.",
    "de-DE": "Menschen können darin einkaufen. Agenten können ihn finden.",
    "it-IT": "Le persone possono acquistare. Gli agenti possono trovarlo.",
    "fr-FR": "Les gens peuvent acheter. Les agents peuvent le trouver.",
    "es-ES": "Las personas pueden comprar. Los agentes pueden encontrarlo.",
    "ru-RU": "Люди могут покупать. Агенты могут его находить.",
  },
});
